import React, { FC } from 'react';

export interface IScreenShotOverlayProps {
    eventTheme?: Nullable<SpApi.Client.IEventTheme>;
    brandName?: string;
    isKeyboardTrigger?: boolean;
    warningTitle?: string;
    warningBody?: string;
}

const ScreenShotOverlay: FC<IScreenShotOverlayProps> = ({
    eventTheme,
    brandName,
    isKeyboardTrigger = true,
    warningTitle,
    warningBody
}) => {
    const isLightTheme = eventTheme?.colorScheme === 'light';
    const backgroundColor = isLightTheme ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)';
    const textColor = isLightTheme ? '#000000' : '#ffffff';
    const textShadow = isLightTheme
        ? '1px 1px 2px rgba(255, 255, 255, 0.8)'
        : '2px 2px 4px rgba(0, 0, 0, 0.8)';
    const smallTextShadow = isLightTheme
        ? '1px 1px 2px rgba(255, 255, 255, 0.8)'
        : '1px 1px 2px rgba(0, 0, 0, 0.8)';

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor,
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                color: textColor,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 999999,
                padding: '40px',
                textAlign: 'center'
            }}
        >
            {/* Studio Logo or Name */}
            {eventTheme?.eventBrandLogo ? (
                <div
                    style={{
                        marginBottom: '40px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <img
                        alt={eventTheme.logoAltText || brandName || ''}
                        src={eventTheme.eventBrandLogo.displayUrl.original}
                        style={{
                            maxHeight: '220px',
                            maxWidth: '220px',
                            height: 'auto',
                            width: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            ) : brandName ? (
                <div
                    style={{
                        marginBottom: '40px',
                        fontSize: '32px',
                        fontWeight: '600',
                        textShadow: smallTextShadow
                    }}
                >
                    {brandName}
                </div>
            ) : null}

            {/* Main Warning Text - Only show for keyboard triggers */}
            {isKeyboardTrigger && (
                <>
                    <div
                        style={{
                            fontSize: '48px',
                            fontWeight: 'bold',
                            textShadow,
                            marginBottom: '40px'
                        }}
                    >
                        {warningTitle}
                    </div>
                    <div
                        style={{
                            fontSize: '24px',
                            maxWidth: '800px',
                            lineHeight: '1.6',
                            textShadow: smallTextShadow
                        }}
                    >
                        {warningBody}
                    </div>
                </>
            )}
        </div>
    );
};

export default ScreenShotOverlay;
